import Vue from 'vue';

const state = {
  action_filters_visible: false,
  action_filters: {
    assigneeId: ['All'],
    type: ['All'],
    dates: { start: null, end: null },
    projectId: ['All'],
    existLinkedDocs: false,
  },
};

const getters = {
  action_filters(state) {
    return state.action_filters;
  },
  action_filters_visible(state) {
    return state.action_filters_visible;
  },
};

const mutations = {
  setActionFilter(state, payload) {
    Vue.set(state.action_filters, payload.key, payload.value);
  },
  setActionFilters(state, payload) {
    state.action_filters = payload;
  },
  resetActionFilters(context) {
    state.action_filters = {
      assigneeId: [context.getters.app_user.id],
      type: ['All'],
      dates: { start: null, end: null },
      projectId: ['All'],
      existLinkedDocs: false,
    };
  },
  setActionFiltersVisible(state, payload) {
    state.action_filters_visible = payload;
  },
};

const actions = {
  setActionFilter(context, payload) {
    context.commit('setActionFilter', payload);
  },
  setActionFilters(context, payload) {
    context.commit('setActionFilters', payload);
  },
  resetActionFilters(context) {
    context.commit('resetActionFilters');
  },
  setActionFiltersVisible(context, payload) {
    context.commit('setActionFiltersVisible', payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
